import React from 'react';
import { useGeneralStore } from 'src/store';

interface ContractShellProps {
  children: React.ReactNode;
}

/**
 * Standalone hosted-page surface for the public contract signing link — same
 * visual family as the W2 employee flow's `W2Shell` (this link also lands in an
 * email, usually opened on a phone). Deliberately no app navigation, no admin
 * chrome: just the group logo (when branding has resolved) above a single card.
 * Wider than `W2Shell` because it hosts the full contract render.
 */
export const ContractShell: React.FC<ContractShellProps> = ({ children }) => {
  const logo = useGeneralStore((s) => s.siteConfig?.logo);

  return (
    <div className="min-h-screen w-full bg-[#f4f4f7]">
      {logo && (
        <div className="border-b border-[#ececf2] bg-white py-3.5 text-center">
          <img src={logo} alt="logo" className="mx-auto h-auto w-36" />
        </div>
      )}
      <div className="mx-auto mb-15 mt-6 w-full max-w-[860px] px-4">
        <div className="rounded-2xl border border-[#ececf2] bg-white px-4.5 py-5.5 sm:px-11 sm:py-10">
          {children}
        </div>
      </div>
    </div>
  );
};
